module.exports = __webpack_public_path__ + "img/profile-complete.ee74204a.svg";